import { render } from "./CollectionListItem.vue?vue&type=template&id=76166921&scoped=true"
import script from "./CollectionListItem.vue?vue&type=script&lang=js"
export * from "./CollectionListItem.vue?vue&type=script&lang=js"

import "./CollectionListItem.vue?vue&type=style&index=0&id=76166921&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76166921"]])

export default __exports__